var Codec = require('io/codec');
var ConversationId = require('conversation/conversation-id');
var CIDSerialiser = {
    read : function(input) {
        return new ConversationId(Codec.readInt64(input));
    },
    write : function(out, cid) {
        Codec.writeInt64(out, cid.val);
    }
};

module.exports = CIDSerialiser;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/conversation/conversation-id-serialiser.js
// module id = 48
// module chunks = 1